import { createAsyncThunk } from '@reduxjs/toolkit';
import Api from '../../api';

export const getLaboratoryPage = createAsyncThunk('laboratoryPage/getLaboratoryPage', async (payload, thunkAPI) => {
  try {
    const { data } = await Api.getLaboratoryPage();
    return data;
  } catch (e) {
    return thunkAPI.rejectWithValue(e.response.data);
  }
});
